export const crmRecentActionsLabels = {
    de: {
        title: 'Letzte Aktionen',
        subtitle: 'Wer hat wann was im CRM angelegt, geändert oder gelöscht? Die Übersicht zeigt protokollierte Änderungen und führt zur zugehörigen Akte.',
        employee: 'Mitarbeiter',
        when: 'Zeitpunkt',
        what: 'Aktion',
        customer: 'Geschäftspartner',
        target: 'Datensatz',
        changes: 'Geänderte Bereiche',
        search: 'Partner, Mitarbeiter oder Datensatz suchen',
        all: 'Alle',
        from: 'Von',
        to: 'Bis',
        newest: 'Neueste zuerst',
        oldest: 'Älteste zuerst',
        sort: 'Sortierung',
        refresh: 'Aktualisieren',
        export: 'CSV exportieren',
        reset: 'Filter zurücksetzen',
        empty: 'Keine protokollierten Aktionen für diese Auswahl.',
        denied: 'Diese Übersicht ist Inhabern und Administratoren mit CRM-Leserecht vorbehalten.',
        unknownActor: 'Bearbeiter nicht mehr zuordenbar',
        deletedPartner: 'Geschäftspartner gelöscht',
        openRecord: 'Akte öffnen',
        invalidRange: 'Das Enddatum darf nicht vor dem Startdatum liegen.',
        invalidFilters: 'Bitte die Filter prüfen und gültige Kalenderdaten eingeben.',
        exportLimit: 'Der Export ist auf 5000 Aktionen begrenzt. Bitte den Zeitraum oder die Filter eingrenzen.',
        actorsLimited: 'Nicht alle Mitarbeiter werden angezeigt. Grenze die Suche oder den Zeitraum ein.',
        timeZoneHint: 'Zeiten in {{timeZone}}. Der Zeitpunkt beschreibt die protokollierte Bearbeitung, nicht ein nachträglich eingetragenes Kontakt- oder Besuchsdatum.',
        timestampUtc: 'Zeitpunkt (UTC)',
        timeZone: 'Mandantenzeitzone',
        actorId: 'Bearbeiterkennung',
        entities: {
            PARTNER: 'Geschäftspartner',
            CONTACT: 'Ansprechpartner',
            ADDRESS: 'Adresse',
            NOTE: 'Notiz',
            CALL: 'Telefonnotiz',
            ACTIVITY: 'CRM-Aktivität',
            TASK: 'Vertriebsaufgabe',
            TASK_COMMENT: 'Aufgabenkommentar',
            TASK_CHECKLIST: 'Aufgabencheckliste',
        },
        actions: {
            CREATE: 'Angelegt',
            UPDATE: 'Geändert',
            DELETE: 'Gelöscht',
            POST: 'Festgeschrieben',
            APPROVE: 'Freigegeben',
            CANCEL: 'Storniert',
        },
        fields: {
            name: 'Bezeichnung / Name',
            contact: 'Kontaktdaten',
            address: 'Adressdaten',
            status: 'Status / Rollen',
            conditions: 'Konditionen',
            assignment: 'Zuständigkeit / Zuweisung',
            dueDate: 'Fälligkeit / Wiedervorlage',
            note: 'Notiz / Text',
            result: 'Ergebnis / Erledigung',
            customFields: 'Zusatzfelder',
            activity: 'Aktivitätsdaten',
        },
    },
    en: {
        title: 'Recent actions',
        subtitle: 'Who created, changed or deleted what in CRM, and when? This overview shows recorded changes and links to the related record.',
        employee: 'Employee',
        when: 'Time',
        what: 'Action',
        customer: 'Business partner',
        target: 'Record',
        changes: 'Changed areas',
        search: 'Search partner, employee or record',
        all: 'All',
        from: 'From',
        to: 'To',
        newest: 'Newest first',
        oldest: 'Oldest first',
        sort: 'Sort order',
        refresh: 'Refresh',
        export: 'Export CSV',
        reset: 'Reset filters',
        empty: 'No recorded actions match this selection.',
        denied: 'This overview is restricted to owners and administrators with CRM read access.',
        unknownActor: 'Editor no longer identifiable',
        deletedPartner: 'Business partner deleted',
        openRecord: 'Open record',
        invalidRange: 'The end date cannot precede the start date.',
        invalidFilters: 'Check the filters and enter valid calendar dates.',
        exportLimit: 'Exports are limited to 5000 actions. Narrow the dates or filters.',
        actorsLimited: 'Not all employees are shown. Narrow the search or date range.',
        timeZoneHint: 'Times in {{timeZone}}. This is the recorded editing time, not a retrospectively entered contact or visit date.',
        timestampUtc: 'Time (UTC)',
        timeZone: 'Tenant time zone',
        actorId: 'Editor identifier',
        entities: {
            PARTNER: 'Business partner',
            CONTACT: 'Contact',
            ADDRESS: 'Address',
            NOTE: 'Note',
            CALL: 'Call note',
            ACTIVITY: 'CRM activity',
            TASK: 'Sales task',
            TASK_COMMENT: 'Task comment',
            TASK_CHECKLIST: 'Task checklist',
        },
        actions: {
            CREATE: 'Created',
            UPDATE: 'Changed',
            DELETE: 'Deleted',
            POST: 'Posted',
            APPROVE: 'Approved',
            CANCEL: 'Cancelled',
        },
        fields: {
            name: 'Label / name',
            contact: 'Contact details',
            address: 'Address details',
            status: 'Status / roles',
            conditions: 'Terms',
            assignment: 'Responsibility / assignment',
            dueDate: 'Due date / follow-up',
            note: 'Note / text',
            result: 'Outcome / completion',
            customFields: 'Custom fields',
            activity: 'Activity details',
        },
    },
    fr: {
        title: 'Dernières actions',
        subtitle: 'Qui a créé, modifié ou supprimé quoi dans le CRM, et quand ? Cette vue présente les changements enregistrés et ouvre le dossier associé.',
        employee: 'Collaborateur',
        when: 'Date et heure',
        what: 'Action',
        customer: 'Partenaire',
        target: 'Enregistrement',
        changes: 'Rubriques modifiées',
        search: 'Rechercher partenaire, collaborateur ou enregistrement',
        all: 'Tous',
        from: 'Du',
        to: 'Au',
        newest: 'Plus récentes d’abord',
        oldest: 'Plus anciennes d’abord',
        sort: 'Tri',
        refresh: 'Actualiser',
        export: 'Exporter en CSV',
        reset: 'Réinitialiser les filtres',
        empty: 'Aucune action enregistrée pour cette sélection.',
        denied: 'Cette vue est réservée aux propriétaires et administrateurs disposant du droit de lecture CRM.',
        unknownActor: 'Auteur non identifiable',
        deletedPartner: 'Partenaire supprimé',
        openRecord: 'Ouvrir le dossier',
        invalidRange: 'La date de fin ne peut pas précéder la date de début.',
        invalidFilters: 'Vérifiez les filtres et saisissez des dates valides.',
        exportLimit: 'L’export est limité à 5000 actions. Réduisez la période ou les filtres.',
        actorsLimited: 'Tous les collaborateurs ne sont pas affichés. Précisez la recherche ou la période.',
        timeZoneHint: 'Heures en {{timeZone}}. Il s’agit de l’heure enregistrée de modification, pas de la date de contact ou visite saisie ultérieurement.',
        timestampUtc: 'Date et heure (UTC)',
        timeZone: 'Fuseau du mandant',
        actorId: 'Identifiant de l’auteur',
        entities: {
            PARTNER: 'Partenaire',
            CONTACT: 'Interlocuteur',
            ADDRESS: 'Adresse',
            NOTE: 'Note',
            CALL: 'Note d’appel',
            ACTIVITY: 'Activité CRM',
            TASK: 'Tâche commerciale',
            TASK_COMMENT: 'Commentaire de tâche',
            TASK_CHECKLIST: 'Liste de contrôle de tâche',
        },
        actions: {
            CREATE: 'Création',
            UPDATE: 'Modification',
            DELETE: 'Suppression',
            POST: 'Validation définitive',
            APPROVE: 'Approbation',
            CANCEL: 'Annulation',
        },
        fields: {
            name: 'Libellé / nom',
            contact: 'Coordonnées',
            address: 'Adresse',
            status: 'Statut / rôles',
            conditions: 'Conditions',
            assignment: 'Responsabilité / affectation',
            dueDate: 'Échéance / rappel',
            note: 'Note / texte',
            result: 'Résultat / achèvement',
            customFields: 'Champs personnalisés',
            activity: 'Données d’activité',
        },
    },
    es: {
        title: 'Últimas acciones',
        subtitle: '¿Quién creó, modificó o eliminó qué en el CRM y cuándo? Esta vista muestra cambios registrados y abre el expediente asociado.',
        employee: 'Empleado',
        when: 'Fecha y hora',
        what: 'Acción',
        customer: 'Socio comercial',
        target: 'Registro',
        changes: 'Áreas modificadas',
        search: 'Buscar socio, empleado o registro',
        all: 'Todos',
        from: 'Desde',
        to: 'Hasta',
        newest: 'Más recientes primero',
        oldest: 'Más antiguas primero',
        sort: 'Orden',
        refresh: 'Actualizar',
        export: 'Exportar CSV',
        reset: 'Restablecer filtros',
        empty: 'No hay acciones registradas para esta selección.',
        denied: 'Esta vista está reservada a propietarios y administradores con permiso de lectura del CRM.',
        unknownActor: 'Autor ya no identificable',
        deletedPartner: 'Socio comercial eliminado',
        openRecord: 'Abrir expediente',
        invalidRange: 'La fecha final no puede preceder a la inicial.',
        invalidFilters: 'Revise los filtros e introduzca fechas válidas.',
        exportLimit: 'La exportación se limita a 5000 acciones. Reduzca el período o los filtros.',
        actorsLimited: 'No se muestran todos los empleados. Reduzca la búsqueda o el período.',
        timeZoneHint: 'Horas en {{timeZone}}. Es la hora registrada de edición, no una fecha de contacto o visita introducida posteriormente.',
        timestampUtc: 'Fecha y hora (UTC)',
        timeZone: 'Zona horaria del mandante',
        actorId: 'Identificador del autor',
        entities: {
            PARTNER: 'Socio comercial',
            CONTACT: 'Contacto',
            ADDRESS: 'Dirección',
            NOTE: 'Nota',
            CALL: 'Nota de llamada',
            ACTIVITY: 'Actividad CRM',
            TASK: 'Tarea comercial',
            TASK_COMMENT: 'Comentario de tarea',
            TASK_CHECKLIST: 'Lista de control de tarea',
        },
        actions: {
            CREATE: 'Creación',
            UPDATE: 'Modificación',
            DELETE: 'Eliminación',
            POST: 'Registro definitivo',
            APPROVE: 'Aprobación',
            CANCEL: 'Anulación',
        },
        fields: {
            name: 'Denominación / nombre',
            contact: 'Datos de contacto',
            address: 'Datos de dirección',
            status: 'Estado / roles',
            conditions: 'Condiciones',
            assignment: 'Responsable / asignación',
            dueDate: 'Vencimiento / seguimiento',
            note: 'Nota / texto',
            result: 'Resultado / finalización',
            customFields: 'Campos personalizados',
            activity: 'Datos de actividad',
        },
    },
    tr: {
        title: 'Son işlemler',
        subtitle: 'CRM’de kim, neyi, ne zaman oluşturdu, değiştirdi veya sildi? Bu görünüm kaydedilmiş değişiklikleri gösterir ve ilgili kaydı açar.',
        employee: 'Çalışan',
        when: 'Zaman',
        what: 'İşlem',
        customer: 'İş ortağı',
        target: 'Kayıt',
        changes: 'Değişen alanlar',
        search: 'İş ortağı, çalışan veya kayıt ara',
        all: 'Tümü',
        from: 'Başlangıç',
        to: 'Bitiş',
        newest: 'En yeniler önce',
        oldest: 'En eskiler önce',
        sort: 'Sıralama',
        refresh: 'Yenile',
        export: 'CSV dışa aktar',
        reset: 'Filtreleri sıfırla',
        empty: 'Bu seçim için kaydedilmiş işlem yok.',
        denied: 'Bu görünüm CRM okuma yetkisine sahip işyeri sahipleri ve yöneticiler içindir.',
        unknownActor: 'Düzenleyen artık belirlenemiyor',
        deletedPartner: 'İş ortağı silindi',
        openRecord: 'Kaydı aç',
        invalidRange: 'Bitiş tarihi başlangıç tarihinden önce olamaz.',
        invalidFilters: 'Filtreleri kontrol edip geçerli takvim tarihleri girin.',
        exportLimit: 'Dışa aktarma 5000 işlemle sınırlıdır. Tarihleri veya filtreleri daraltın.',
        actorsLimited: 'Tüm çalışanlar gösterilmiyor. Aramayı veya tarih aralığını daraltın.',
        timeZoneHint: 'Saatler {{timeZone}} dilimindedir. Bu, sonradan girilmiş görüşme veya ziyaret tarihi değil, kaydedilen düzenleme zamanıdır.',
        timestampUtc: 'Zaman (UTC)',
        timeZone: 'Mandant saat dilimi',
        actorId: 'Düzenleyen kimliği',
        entities: {
            PARTNER: 'İş ortağı',
            CONTACT: 'İlgili kişi',
            ADDRESS: 'Adres',
            NOTE: 'Not',
            CALL: 'Telefon notu',
            ACTIVITY: 'CRM etkinliği',
            TASK: 'Satış görevi',
            TASK_COMMENT: 'Görev yorumu',
            TASK_CHECKLIST: 'Görev kontrol listesi',
        },
        actions: {
            CREATE: 'Oluşturuldu',
            UPDATE: 'Değiştirildi',
            DELETE: 'Silindi',
            POST: 'Kesinleştirildi',
            APPROVE: 'Onaylandı',
            CANCEL: 'İptal edildi',
        },
        fields: {
            name: 'Tanım / ad',
            contact: 'İletişim bilgileri',
            address: 'Adres bilgileri',
            status: 'Durum / roller',
            conditions: 'Koşullar',
            assignment: 'Sorumluluk / atama',
            dueDate: 'Vade / takip',
            note: 'Not / metin',
            result: 'Sonuç / tamamlama',
            customFields: 'Ek alanlar',
            activity: 'Etkinlik bilgileri',
        },
    },
};
//# sourceMappingURL=crm-recent-actions-labels.js.map